var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "transcript-link-fields az-card-bordered no-padding no-shadow d-flex flex-column flex-sm-row"
    },
    _vm._l(_vm.fields, function(field, index) {
      return _c(
        "div",
        {
          key: field.key,
          staticClass:
            "transcript-link-fields__column d-flex flex-column az-gap-xsmall px-4 py-3",
          class: { "transcript-link-fields__column--divided": index > 0 }
        },
        [
          _c("span", { staticClass: "az-ds-label" }, [
            _vm._v(_vm._s(field.label))
          ]),
          _c(
            "div",
            { staticClass: "d-flex align-center az-gap-xsmall" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "az-text-primary az-size-14 font-medium text-truncate",
                  attrs: { title: field.value }
                },
                [_vm._v(" " + _vm._s(field.value) + " ")]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "transcript-link-fields__edit az-ds-aux d-inline-flex align-center",
                                    attrs: {
                                      type: "button",
                                      "aria-label": field.tooltip
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit(field.event)
                                      }
                                    }
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: { name: "edit", size: "14" }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_c("span", [_vm._v(_vm._s(field.tooltip))])]
              )
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }